<h2 mat-dialog-title>Delete</h2>
<mat-dialog-content>Weet je zeker dat je dit item wilt verwijderen?</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button 
    class="button-standard-action"
    mat-dialog-close>Nee</button>
  <button mat-raised-button 
    class="button-primary-action"
    [mat-dialog-close]="true">Ja</button>
</mat-dialog-actions>
